import React from "react";
import { serviceLogoUrl } from "../../helpers/ServiceLogo";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import mainHelper, {apiCall} from "../../helpers/MainHelper";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import Select from "react-select";
class Business extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      business:[],
      formData : {
        id:'',
        name:'',
        phone:'',
        address:'',
        employe_number:'',
        branch_number:'',
        created_at:'',
        updated_at:'',
        logo:'',
        web_site:'',
        service_title:'',
        tax_no:'',
        tax_district:'',
        facilities:'',
        about_service:'',
        gib_usercode:'',
        gib_password:'',
        urn:'',
        working_days: {
          Pazartesi: { isWorking: false, start: '', end: '' },
          Salı: { isWorking: false, start: '', end: '' },
          Çarşamba: { isWorking: false, start: '', end: '' },
          Perşembe: { isWorking: false, start: '', end: '' },
          Cuma: { isWorking: false, start: '', end: '' },
          Cumartesi: { isWorking: false, start: '', end: '' },
          Pazar: { isWorking: false, start: '', end: '' },
        },

      },
      loading:false,
      isLoad:true,
      logoPreview:'',
      categories:[],
      selectedOptions: []
    }
  }
  componentDidMount() {
    this.getBusinessInfo();
    this.getCategories();
  }
  getCategories = async () => {
    try {
      const response = await apiCall('business/get-categories', 'get', null);
      this.setState({ categories: response });
    }
    catch (e) {
        this.setState({ isLoad: false });
        console.log(e);
      }
  }
  getBusinessInfo = async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    try {
      const response = await apiCall('business/info/' + user.service.id, 'get', null);
      const updatedData = { ...this.state.formData };
      Object.keys(updatedData).forEach(key => {
        if (key !== 'logo'){
          updatedData[key] = response[key] === undefined || response[key] === null ? "" : response[key];
        }

      });
      const formattedSelectedOptions = response['categories'].map(option => ({
        value: option.id,
        label: option.name
      }));
      updatedData['created_at'] = mainHelper.dateFormat(response['created_at']);
      if (!response.working_days) {

        updatedData['working_days'] = {
          Pazartesi: { isWorking: false, start: '', end: '' },
          Salı: { isWorking: false, start: '', end: '' },
          Çarşamba: { isWorking: false, start: '', end: '' },
          Perşembe: { isWorking: false, start: '', end: '' },
          Cuma: { isWorking: false, start: '', end: '' },
          Cumartesi: { isWorking: false, start: '', end: '' },
          Pazar: { isWorking: false, start: '', end: '' },
        };
      } else {
        updatedData['working_days'] = JSON.parse(response.working_days);
      }
      
      // Backend'den logo_url accessor'ı ile gelen URL'i kullan
      // Eğer yoksa fallback olarak storage type'a göre URL oluştur
      const logoUrl = serviceLogoUrl(response);

      this.setState({ formData: updatedData,logoPreview:logoUrl,selectedOptions:formattedSelectedOptions }, () => {
        this.setState({ isLoad: false });
      });
    } catch (e) {
      this.setState({ isLoad: false });
      console.log(e);
    }
  }
  handleCheckboxChange = (day) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        working_days: {
          ...prevState.formData.working_days,
          [day]: {
            ...prevState.formData.working_days[day],
            isWorking: !prevState.formData.working_days[day].isWorking,
          },
        },
      },
    }));
  };

  handleTimeChange = (day, type, value) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        working_days: {
          ...prevState.formData.working_days,
          [day]: {
            ...prevState.formData.working_days[day],
            [type]: value,
          },
        },
      },
    }));
  };
  handleSelectChange = (selectedOptions) => {
    const formattedSelectedOptions = selectedOptions ? selectedOptions.map(option => ({
      value: option.value,
      label: option.label
    })) : [];

    this.setState({
      selectedOptions: formattedSelectedOptions
    });
  };
  handleChange = (e) => {
    const { id, value, files } = e.target;
    const formData = { ...this.state.formData };

    if (id === 'logo' && files[0]) {
      const reader = new FileReader();
      reader.onloadend = () => {
        formData.logo = files[0];
        this.setState({ logoPreview:reader.result });
        this.setState({ formData });
      };
      reader.readAsDataURL(files[0]);
    } else {
      formData[id] = value;
      this.setState({ formData });
    }
  };
  handleSubmit = async (e) => {
    e.preventDefault();
    const user = JSON.parse(localStorage.getItem('user'));
    this.setState({loading:true});
    const id = user.service.id;
    const {formData,selectedOptions} = this.state;
    const businessFormData = new FormData();
    Object.keys(formData).forEach(key => {
      if (key !== 'working_days') {
        businessFormData.append(key, formData[key]);
      }
    });

    businessFormData.append('working_days', JSON.stringify(formData.working_days));
    const selectedValues = selectedOptions.map(option => option.value);
    businessFormData.append('categories', JSON.stringify(selectedValues));
    try {
      const response = await apiCall('business/update/'+id,'post',businessFormData);
      this.setState({loading:false});
      mainHelper.toastMessage(response.status,response.message);
    }catch (e) {
      this.setState({loading:false});
    }

  }
  render() {
    const {formData,loading,logoPreview,categories,selectedOptions} = this.state;
    const {working_days} = formData;
    const weekDays = ["Pazartesi", "Salı", "Çarşamba", "Perşembe", "Cuma", "Cumartesi", "Pazar"];
    const {userPermissions} = this.props;
    const userHasUpdateBusinessInfoPermission = userPermissions.includes('update business');
    const formattedOptions = categories.map(option => ({
      value: option.id,
      label: option.name
    }));


    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{display: this.state.isLoad ? 'block' : 'none'}}>
            <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid"/>
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="İşletme Ayarları"
                Breadcrumb={[
                  {name: "Ayarlar", navigate: ""},
                  {name: "İşletme Ayarları", navigate: ""},
                ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <label className="float-right text-cyan">Oluşturulma Tarihi :<span className="text-muted"> {formData.created_at || ''}</span></label>
                <div className="card">
                  <form onSubmit={this.handleSubmit}>
                    <div className="body">
                      <div className="row clearfix">
                        <div className="col-lg-12 col-md-12 text-center">
                          <div className="form-group">
                            <img name="logoPreview" alt='logo' width="150" src={logoPreview}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <label htmlFor="name" className="font-weight-bold text-cyan">
                              İşletme Adı
                            </label>
                            <input
                                id="name"
                                className="form-control"
                                placeholder="İşletme Adı"
                                type="text"
                                value={formData.name || ''}
                                onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="phone" className="font-weight-bold text-cyan">
                              İşletme Telefon
                            </label>
                            <input
                                id="phone"
                                className="form-control"
                                placeholder="İşletme Telefon"
                                type="text"
                                value={formData.phone || ''}
                                onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="branch_number" className="font-weight-bold text-cyan">
                              İşletme Adresi
                            </label>
                            <textarea
                                id="address"
                                className="form-control textarea-service-address-height"
                                placeholder="İşletme Adresi"
                                value={formData.address || ''}
                                onChange={this.handleChange}>
                            </textarea>
                          </div>
                          <div className="form-group">
                            <label htmlFor="web_site" className="font-weight-bold text-cyan">
                              İşletme Web Sitesi
                            </label>
                            <input
                                id="web_site"
                                className="form-control"
                                placeholder="İşletme Web Sitesi"
                                type="text"
                                value={formData.web_site || ''}
                                onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <label htmlFor="service_title" className="font-weight-bold text-cyan">
                              İşletme Ünvanı
                            </label>
                            <input
                                id="service_title"
                                className="form-control"
                                placeholder="İşletme Ünvanı"
                                type="text"
                                value={formData.service_title || ''}
                                onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="tax_no" className="font-weight-bold text-cyan">
                              Vergi No
                            </label>
                            <input
                                id="tax_no"
                                className="form-control"
                                placeholder="Vergi No"
                                type="number"
                                value={formData.tax_no || ''}
                                onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="tax_district" className="font-weight-bold text-cyan">
                              Vergi Dairesi
                            </label>
                            <input
                                id="tax_district"
                                className="form-control"
                                placeholder="Vergi Dairesi"
                                type="text"
                                value={formData.tax_district || ''}
                                onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="employe_number" className="font-weight-bold text-cyan">
                              Çalışan Sayısı
                            </label>
                            <input
                                id="employe_number"
                                className="form-control"
                                placeholder="Çalışan Sayısı"
                                type="number"
                                value={formData.employe_number || ''}
                                onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <label htmlFor="name" className="font-weight-bold text-cyan">
                              İşletme Logosu
                            </label>
                            <input
                                id="logo"
                                className="form-control"
                                type="file"
                                onChange={this.handleChange}
                            />
                          </div>

                          <div className="form-group">
                          <label htmlFor="gib_usercode" className="font-weight-bold text-cyan">
                              Gib Kullanıcı Kodu
                            </label>
                            <input
                                id="gib_usercode"
                                className="form-control"
                                placeholder="Gib Kullanıcı Kodu"
                                type="text"
                                value={formData.gib_usercode || ''}
                                onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="gib_password" className="font-weight-bold text-cyan">
                              Gib Şifre
                            </label>
                            <input
                                id="gib_password"
                                className="form-control"
                                placeholder="Gib Şifre"
                                type="password"
                                value={formData.gib_password || ''}
                                onChange={this.handleChange}
                            />
                          </div>
                          <div className="form-group">
                            <label htmlFor="urn" className="font-weight-bold text-cyan">
                              Fatura Urn Adresi
                            </label>
                            <input
                                id="urn"
                                className="form-control"
                                placeholder="Fatura Urn Adresi"
                                type="text"
                                value={formData.urn || ''}
                                onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <label htmlFor="categories" className="font-weight-bold text-cyan">
                              Verdiğiniz Hizmetler
                            </label>
                            <Select
                                isMulti
                                placeholder="Seçiniz..."
                                options={formattedOptions}
                                value={selectedOptions}
                                onChange={this.handleSelectChange}
                            />

                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <label htmlFor="facilities" className="font-weight-bold text-cyan">
                              Sunduğunuz İmkanlar <small>- Virgül ile ayırarak yazınız.</small>
                            </label>
                            <textarea
                                id="facilities"
                                className="form-control textarea-facilicty-height"
                                placeholder="Park yeri,İçecek,vs.."
                                value={formData.facilities || ''}
                                onChange={this.handleChange}
                            />
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="form-group">
                            <label htmlFor="about_service" className="font-weight-bold text-cyan">
                              İşletmeniz Hakkında
                            </label>
                            <textarea
                                id="about_service"
                                className="form-control textarea-about-service-height"
                                placeholder="İşletmeniz Hakkında"
                                value={formData.about_service || ''}
                                onChange={this.handleChange}>
                             </textarea>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">

                        </div>
                        <div className="col-lg-12 col-md-12">
                          <table className="table table-bordered" style={{tableLayout: 'fixed'}}>
                            <thead>
                            <tr>
                              <th style={{width: '25%'}}>Gün</th>
                              <th style={{width: '15%'}}>Çalışıyor mu?</th>
                              <th style={{width: '30%'}}>Başlangıç Saati</th>
                              <th style={{width: '30%'}}>Bitiş Saati</th>
                            </tr>
                            </thead>
                            <tbody>
                            {weekDays.map((day) => (
                                <tr key={day} style={{width: '100%'}}>
                                  <td>{day}</td>
                                  <td className="text-center">
                                    <div className="fancy-checkbox">
                                    <label>
                                        <input
                                            type="checkbox"
                                            checked={working_days[day].isWorking}
                                            onChange={() => this.handleCheckboxChange(day)}
                                        />
                                        <span></span>
                                      </label>
                                    </div>
                                  </td>
                                  {working_days[day].isWorking ? (
                                      <>
                                        <td>
                                          <input
                                              type="time"
                                              value={working_days[day].start}
                                              onChange={(e) => this.handleTimeChange(day, 'start', e.target.value)}
                                              className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                              type="time"
                                              value={working_days[day].end}
                                              onChange={(e) => this.handleTimeChange(day, 'end', e.target.value)}
                                              className="form-control"
                                          />
                                        </td>
                                      </>
                                  ) : (
                                      <>
                                        <td>
                                          <input
                                              type="time"
                                              onChange={(e) => this.handleTimeChange(day, 'start', e.target.value)}
                                              className="form-control"
                                          />
                                        </td>
                                        <td>
                                          <input
                                              type="time"
                                              onChange={(e) => this.handleTimeChange(day, 'end', e.target.value)}
                                              className="form-control"
                                          />
                                        </td>
                                      </>
                                  )}
                                </tr>
                            ))}
                            </tbody>
                          </table>
                        </div>
                      </div>

                    </div>
                    <div className="body">
                      <div className="row clearfix justify-content-center">
                        <div className="col-lg-6 col-md-12">
                          {loading ? (
                                  <button className="btn btn-outline-primary btn-block" disabled={true}
                                          style={{textAlign: "-webkit-center"}}>
                                    Lütfen Bekleyin...<ReactLoading type="spin" width={'24px'} height={'24px'}
                                                                    color="#268bd2"></ReactLoading>
                                  </button>
                              ) :
                              <button disabled={!userHasUpdateBusinessInfoPermission}
                                      className="btn btn-outline-primary btn-block" type="submit">
                                Güncelle
                              </button>}
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ioTReducer}) => ({
  isSecuritySystem: ioTReducer.isSecuritySystem,
});

export default withPermissions(withRouter(connect(mapStateToProps, {})(Business)));
